import React, { useEffect } from "react";

import { ToastProvider, useToast, setToastRef } from "./ToastContext";

const ToastRefSetter = ({ children }) => {
  const toast = useToast();

  useEffect(() => {
    setToastRef(toast);
  }, [toast]);

  return children;
};

export const GlobalToastProvider = ({ children }) => (
  <ToastProvider>
    <ToastRefSetter>{children}</ToastRefSetter>
  </ToastProvider>
);

export {
  showSuccessToast,
  showErrorToast,
  showWarningToast,
  showInfoToast,
  hideToast,
  useToast,
} from "./ToastContext";

export { default as CustomToast } from "./CustomToast";
